// ==============================================
// ===================Imports====================
// ==============================================
// ==============================================

// =================ACTIONS=====================
import {
  SET_LOADING_NODE_INFO_MAP,
  SET_LOADING_NODE_INFO_TAB,
  SET_SAVE_MAP_NODE_INFO_PAGE,
  SET_SAVE_NODE_INFO_MARKER_ARRAY,
  SET_SAVE_NODE_INFO_MARKER_COMPONENT,
  SET_SAVE_NODE_INFO_MARKER_STATIC,
  SET_SAVE_TAB_NODE_INFO_PAGE,
} from '../actions/nodeInfo';

// ==============================================
// ================InitialState==================
// ==============================================
const initialState = {
  nodeInfoPage: {
    nodeInfoMap: '',
    nodeInfoTab: '',
    nodeInfoTabStatic: '',
    loadingNodeInfoMap: true,
    loadingNodeInfoTab: true,
    loadingNodeInfoTabStatic: true,
    markerComponent: [],
    markerComponentStatic: [],
    arrayStatic: [],
  },
};

function nodeInfoReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SAVE_MAP_NODE_INFO_PAGE:
      return {
        ...state,
        nodeInfoPage: {
          ...state.nodeInfoPage,
          nodeInfoMap: action.value,
        },
      };
    case SET_SAVE_TAB_NODE_INFO_PAGE:
      return {
        ...state,
        nodeInfoPage: {
          ...state.nodeInfoPage,
          nodeInfoTab: action.value,
        },
      };
    case SET_LOADING_NODE_INFO_MAP:
      return {
        ...state,
        nodeInfoPage: {
          ...state.nodeInfoPage,
          loadingNodeInfoMap: action.value,
        },
      };
    case SET_LOADING_NODE_INFO_TAB:
      return {
        ...state,
        nodeInfoPage: {
          ...state.nodeInfoPage,
          loadingNodeInfoTab: action.value,
        },
      };
    case SET_SAVE_NODE_INFO_MARKER_COMPONENT:
      return {
        ...state,
        nodeInfoPage: {
          ...state.nodeInfoPage,
          markerComponent: action.value,
        },
      };
    case SET_SAVE_NODE_INFO_MARKER_STATIC:
      return {
        ...state,
        nodeInfoPage: {
          ...state.nodeInfoPage,
          markerComponentStatic: action.value,
        },
      };
    case SET_SAVE_NODE_INFO_MARKER_ARRAY:
      return {
        ...state,
        nodeInfoPage: {
          ...state.nodeInfoPage,
          arrayStatic: action.value,
        },
      };
    default:
      return state;
  }
}

export default nodeInfoReducer;
